<template>
  <div class="users-edit" v-loading="loading">
    <el-form>
      <template v-if="!form.isCompany">
        <el-form-item label="Email">
          <el-input :disabled="true" v-model="form.email" placeholder="Email"/>
        </el-form-item>
        <el-form-item label="Должность">
          <el-input v-model="form.position" placeholder="Должность"/>
        </el-form-item>
        <el-form-item label="Имя Фамилия">
          <el-input v-model="form.name" placeholder="Имя Фамилия"/>
        </el-form-item>
        <el-form-item label="Телефон">
          <el-input v-model="form.phone" placeholder="Телефон"/>
        </el-form-item>
        <el-form-item label="Компания">
          <el-input v-model="form.company" placeholder="Компания"/>
        </el-form-item>
        <div>
          <Notification v-model="form.notification" @save="saveNotification"/>
        </div>
        <el-radio-group v-model="form.role" v-if="!currentUser">

          <el-radio label="admin">Администратор</el-radio>
          <el-radio label="editor">Редактор</el-radio>
          <el-radio label="worker">Стандартный</el-radio>
        </el-radio-group>
        <div v-else style="text-align: left; display: flex; flex: 1; align-items: flex-start; flex-direction: column">
          <strong>Роль</strong>
          <span>{{ form.role }}</span>
        </div>
      </template>
      <template v-else>
        <el-form-item label="Название">
          <el-input v-model="form.company" @input="companyChange" placeholder="Название"/>
        </el-form-item>
        <el-form-item label="Комментарий">
          <el-input v-model="form.comment" type="textarea" textarea/>
        </el-form-item>
      </template>
      <div style="margin-bottom: 20px">
        <PermissionObject v-if="form.isCompany" :id="id" :user="form" @update="updatePermission"/>
        <PermissionDocs v-if="form.isCompany" :id="id" :user="form" @update="updatePermission"/>
      </div>
      <el-button
        style="width: 100%; margin-top: 2px; margin-bottom: 8px"
        @click="deleteUser"
        size="small"
        type="danger"
      >
        Удалить {{ form.isCompany ? 'компанию' : 'пользователя' }} из организации
      </el-button>

      <div class="users-edit__buttons">
        <el-button @click="$router.go(-1)">Отмена</el-button>
        <el-button type="primary" @click="save(false)">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import crypto from 'crypto';
import PermissionObject from "./PermissionObject";
import PermissionDocs from "./PermissionDocs";
import Notification from "./Notification";

export default {
  name: 'Edit',
  components: {Notification, PermissionDocs, PermissionObject},
  data() {
    return {
      loading: false,
      id: null,
      form: {
        notification: {
          enabled: false,
          time_shift: [
            {
              time: null,
              current_day: false
            },
            {
              time: null,
              current_day: false
            },
            {
              time: null,
              current_day: false
            }
          ],
          week: [true, true, true, true, true, false, false]
        },
        name: '',
        position: '',
        role: 'admin',
        email: '',
        phone: '',
        company: '',
        isCompany: false,
        comment: '',
        available_objects: [],
        available_jobs: {},
        available_docs: [],
        available_files: {}
      },
    };
  },

  mounted() {
    this.fetchUser();
  },

  computed: {
    currentUser() {
      return firebase.auth().currentUser.uid === this.$route.params.id;
    },
  },

  methods: {
    companyChange() {
      this.form.name = this.form.company.trim();
    },
    saveNotification() {
      this.save()
    },
    deleteUser() {
      this.$confirm(`Вы действительно хотите удалить ${this.form.isCompany ? 'компанию' : 'пользователя'} из организации?`,
        'Подтверждение',
        {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(async () => {
        let batch = firebase.firestore().batch();
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .where('uid', '==', this.$route.params.id)
          .get().then(async (snapshot) => {
          snapshot.docs.forEach(doc => {
            batch.delete(doc.ref);
          });
          batch.commit();
          const responseData = await firebase
            .firestore()
            .collection('projects')
            .doc(this.$store.state.project.id).get();
          const data = responseData.data();
          delete data.rules[this.$route.params.id];
          firebase
            .firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .update(
              {
                ...responseData.data(),
                rules: {
                  ...data.rules,
                },
              },
            ).then(() => {
            this.$router.push('/dashboard/users');
            this.$notify({
              offset: 60,

              title: 'Успех',
              message: 'Пользователь удален',
              type: 'success',
            });
          });
        });
      });
    },
    fetchUser() {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$route.params.id)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            this.id = subDoc.id;
            this.form = {
              ...this.form,
              ...subDoc.data(),
              role: subDoc.data().role,
            };
          });
        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    updatePermission(user) {
      this.form = user
    },
    async save(flag) {
      this.loading = true;
      firebase.firestore().collection('projects').doc(this.$store.state.project.id).get().then(async (response) => {
        const responseData = response.data();
        await firebase.firestore().collection('projects').doc(this.$store.state.project.id).update(
          {
            ...responseData,
            rules: {
              ...responseData.rules,
              [this.$route.params.id]: this.form.role,
            },
          },
        );
      });
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.id)
        .update({
          ...this.form,
          company: this.form.company.trim()
        }).then((add) => {
          if(!flag) {
            this.$notify({
              offset: 60,

              title: 'Успешно',
              message: 'Данные пользователя изменены',
              type: 'success',
            });
            setTimeout(() => {
              this.$router.push('/dashboard/users');
            });
            return
          }

        this.$notify({
          offset: 60,
          title: 'Успешно',
          message: 'Данные об уведомлениях изменены',
          type: 'success',
        });
      }).catch((error) => {
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-edit {
  max-width: 472px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;

  @media screen and (max-width: 764px) {

    .el-radio-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .el-radio {
        margin-bottom: 10px;
      }
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/Edit.vue